import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/cmore/ellipse_right.png";
import { StaticImage } from "gatsby-plugin-image";

const Solutioncmore = () => {
  return (
    <div
      className="solution_cmore p-100"
      style={{ backgroundImage: `url(${BgImg})`, backgroundColor: "#000" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={7}
            xl={7}
            xxl={7}
            className="my-auto resp_order"
          >
            <StaticImage
              src="../../../images/case-studies/cmore/solution.png"
              alt="TekRevol"
              className="img-fluid d-none d-md-block"
              layout="constrained"
              placeholder="blurred"
              formats={["png"]}
              width={974}
            />
            <StaticImage
              src="../../../images/case-studies/cmore/sol_mob.png"
              alt="TekRevol"
              className="img-fluid d-sm-block d-md-none"
              layout="constrained"
              placeholder="blurred"
              formats={["png"]}
              width={662}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={4}
            xxl={4}
            className="my-auto offset-xl-1 "
          >
            <h2>
              Solutions <span>Delivered</span>
            </h2>
            <p>
              CMORE streamlines the entire procurement process for
              construction-related goods. From browsing products to making a
              purchase and tracking delivery, the end-to-end experience is
              optimized for efficiency. Users, including construction material
              stores, builders, and delivery riders, benefit from real-time
              visibility into orders. The platform provides comprehensive
              tracking features, ensuring that all stakeholders can monitor
              orders and deliveries at any stage. The integrated admin panel
              serves as a centralized management hub. It empowers administrators
              to oversee users, drivers, inventory, orders, payments, and
              communication effectively. This centralized approach enhances
              control and decision-making. The implementation of a secure
              payment gateway ensures that financial transactions on the
              platform are not only seamless but also protected. This fosters
              trust among users, encouraging more transactions and fostering a
              healthy e-commerce ecosystem. The platform facilitates enhanced
              communication between all stakeholders. Through push notifications
              and efficient content management, users, and delivery riders stay
              informed about order statuses, promotions, and other relevant
              information. This proactive communication contributes to a
              positive user experience.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Solutioncmore;
